import { createTheme } from '@mui/material/styles';

export const THEME = createTheme({
  typography: {
    'fontFamily': '`-apple-system, BlinkMacSystemFont, sans-serif`',
  },
  palette: {
    primary: {
      main: '#957db9',
      light: '#f4ebfa',
      dark: '#432a48',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
});